module.exports = __webpack_public_path__ + "assets/avatar-checkmate.03434b33.svg";